import { isUndefined } from "../../util/TypeUtil";

/**
* MCOptionScore.js
* 
* Created on Nov 7, 2013, 2:56:46 PM
*
* @author Javier Quevedo-Fernandez for Ranj
**/
export default class MCOptionScore {
    constructor(variable, addition) {
        this._variable = !isUndefined(variable) ? variable : null;
        this._addition = !isUndefined(addition) ? addition : 0;
    }

    setVariable(value) {
        this._variable = value;
    }

    getVariable() {
        return this._variable;
    }

    setAddition(value) {
        this._addition = value;
    }

    getAddition() {
        return this._addition;
    }
}